import React, { useState } from "react";
import { Form, Input, Card, Button, Select, Typography, Space, Tooltip, DatePicker, Col, Row, Spin } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import CalendarIcon from "@untitled-ui/icons-react/build/esm/Calendar";
import { connect } from "react-redux";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import { useGetTreasuryItem, useGetTreasuryBillItems } from "../../../../treasury/treasuryBill/hooks/useServerActions";

const { Title, Paragraph } = Typography;
const { Option } = Select;

const InstrumentDetailForm = ({ userData, formData, onFinish, form, updateFormData, prodTemplate, productCreatedDate }) => {
  return (
    <div className="form-section">
      <Spin spinning={false} size="large">
        <h2 style={{ margin: 0, fontSize: "24px" }}>Instrument Details</h2>
        <p style={{ marginTop: "5px", color: "#6b7280" }}>Add description text to note for users</p>

        <Form
          onFinish={onFinish}
          form={form}
          layout="vertical"
          // initialValues={formData}
        >
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Space>
                    Instrument
                    <Tooltip title="Instrument">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                name={"instrument"}
              >
                <Select
                  disabled
                  // size="large"
                  options={prodTemplate?.instrumentTypes}
                  placeholder={"Select instrument"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                  className="custom-input read-only-select"
                />
              </Form.Item>
            </Col>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Space>
                    Issuing Authority
                    <Tooltip title="Issuing Authority">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                name={"issuer"}
              >
                <Select
                  showSearch
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                  options={prodTemplate?.issuers}
                  // placeholder="Centeral Bank Of Nigeria (CBN)"
                  placeholder="----"
                  optionFilterProp="children"
                  style={{ height: "44px" }}
                  disabled
                  className="custom-input read-only-select"
                />
              </Form.Item>
            </Col>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Space>
                    Auction Reference
                    <Tooltip title="Auction Reference">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                name={"auctionReference"}
                rules={[
                  {
                    required: true,
                    message: "Auction reference cannot be empty",
                  },
                  {
                    pattern: /^[A-Z0-9]+$/,
                    message: "Auction reference must contain only uppercase letters, numbers and less than 5 characters",
                  },
                  {
                    max: 10,
                    message: "Auction reference must be less than 10 characters",
                  },
                ]}
              >
                <Input
                  placeholder="CBN/NTB20250404"
                  // placeholder="CBN/NTB/2025040"
                  style={{ height: "44px" }}
                />
              </Form.Item>
            </Col>

            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={
                  <Space>
                    Maturity Tenor
                    <Tooltip title="Maturity Tenor">
                      <InfoCircleOutlined />
                    </Tooltip>
                  </Space>
                }
                name={"tenor"}
              >
                <Select
                  disabled
                  // size="large"
                  options={prodTemplate?.tenorOptions}
                  placeholder={"Select tenor"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                  className="custom-input read-only-select"
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label="Issue Date"
                name={"issueDate"}
                style={{ flex: 1 }}
                rules={[
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject(new Error(`Please select issue date`));
                      }
                      if (value?.isBefore(productCreatedDate, "day")) {
                        return Promise.reject(new Error(`Issue date cannot be lesser than ${productCreatedDate.format("YYYY-MM-DD")}`));
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <DatePicker
                  // size="large"
                  style={{ marginBottom: 0, width: "100%" }}
                  placeholder="DD/MM/YYYY"
                  suffixIcon={<CalendarIcon color="#667085" width={20} />}
                  className="bond-date-picker custom-input read-only-select"
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label="Maturity Date" name={"maturityDate"} style={{ flex: 1, fontSize: "14px" }}>
                <DatePicker
                  disabled
                  // size="large"
                  style={{ marginBottom: 0, width: "100%" }}
                  placeholder="DD/MM/YYYY"
                  suffixIcon={<CalendarIcon color="#667085" width={20} />}
                  className="bond-date-picker custom-input read-only-select"
                />
              </Form.Item>
            </Col>
          </Row>

          {/* <div style={{ display: "flex", gap: "20px" }}>
          <Form.Item
            label="Start Date"
            name={["instrumentDetails", "startDate"]}
            style={{ flex: 1 }}
          >
            <DatePicker
              style={{ width: "100%", height: "44px" }}
              format="DD/MM/YYYY"
            />
          </Form.Item>

          <Form.Item
            label="Maturity Date"
            name={["instrumentDetails", "maturityDate"]}
            style={{ flex: 1, fontSize: "14px" }}
          >
            <DatePicker
              style={{ width: "100%", height: "44px" }}
              format="DD/MM/YYYY"
              disabled
            />
          </Form.Item>
        </div> */}
        </Form>
      </Spin>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});

const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(InstrumentDetailForm);
